import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const UnityIntegrationGrid = () => {
  return (
    <section className="py-24 bg-slate-900 text-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-6 leading-tight">
              Turn Your Website Into <br />
              <span className="text-emerald-400">A Box Office Hub.</span>
            </h2>
            <p className="text-slate-400 text-lg mb-12 leading-relaxed">
              Unity widgets are built to convert. Whether it's a sidebar calendar or a full-page event collection, our embedding technology ensures a frictionless checkout experience for your guests.
            </p>
            <div className="space-y-6">
              {[
                { title: "Zero-Latency Loading", desc: "Widgets load instantly, ensuring you never lose a lead to slow performance." },
                { title: "Full CSS Control", desc: "Style our widgets to match your brand's typography, colors, and border widths perfectly." },
                { title: "Auto-Sync Data", desc: "Change an event description in BookMeIn and watch it update across your site in real-time." }
              ].map((item, i) => (
                <div key={i} className="flex gap-4 p-4 rounded-2xl bg-white/5 border border-white/10 hover:bg-white/10 transition-colors">
                  <div className="flex-shrink-0 mt-1">
                    <div className="bg-emerald-500/20 rounded-lg p-2">
                      <SafeIcon icon={FiIcons.FiCheck} className="w-5 h-5 text-emerald-400" />
                    </div>
                  </div>
                  <div>
                    <h4 className="font-bold text-white mb-1">{item.title}</h4>
                    <p className="text-slate-400 text-sm leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            <div className="bg-slate-800 rounded-3xl p-6 shadow-2xl border border-slate-700 relative z-10">
              <div className="flex items-center justify-between mb-8 border-b border-white/10 pb-4">
                <div className="flex gap-2">
                  <div className="w-3 h-3 rounded-full bg-red-500/30"></div>
                  <div className="w-3 h-3 rounded-full bg-yellow-500/30"></div>
                  <div className="w-3 h-3 rounded-full bg-green-500/30"></div>
                </div>
                <div className="px-3 py-1 bg-emerald-500/20 text-emerald-400 text-[10px] font-bold uppercase rounded-full">Active Embed</div>
              </div>
              <div className="space-y-4">
                <div className="h-40 bg-slate-900 rounded-2xl border border-white/5 flex items-center justify-center relative overflow-hidden">
                  <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/10 to-transparent"></div>
                  <SafeIcon icon={FiIcons.FiLayout} className="w-12 h-12 text-emerald-500/50" />
                </div>
                <div className="h-4 w-3/4 bg-white/10 rounded"></div>
                <div className="h-4 w-1/2 bg-white/5 rounded"></div>
                <div className="pt-4 flex gap-3">
                  <div className="h-10 flex-1 bg-emerald-600 rounded-xl"></div>
                  <div className="h-10 w-10 bg-white/10 rounded-xl"></div>
                </div>
              </div>
            </div>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-80 h-80 bg-emerald-500/20 blur-[120px] -z-0"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UnityIntegrationGrid;